// extracted by mini-css-extract-plugin
module.exports = {"instrumentsWrapper":"App_instrumentsWrapper__Mi0U2"};